import { startCase, camelCase } from 'lodash'
import { isEmptyValue } from './common'

export const showControlTypeName = (data) => {
  if (!isEmptyValue(data?.title)) {
    return data?.title
  }
  return startCase(camelCase(data.name))
}
